export default __webpack_public_path__ + "static/media/serviciosAlarma1Mobile.0c950818.png";